import { Component, Input } from '@angular/core';
import { SNModalService } from '@web-services/modal/snModal.service';

@Component({
	selector: 'email-alert-modal',
	template: require('./email-alert-modal.component.html'),
	styles: [require('./email-alert-modal.component.scss')]
})
export class EmailAlertModalComponent {
	@Input() btnDisabled = false;
	@Input() messageToShow = 'Are you sure?';

	constructor(private modalService: SNModalService) {}

	confirmSave(): void {
		this.modalService.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.ts